import { render, staticRenderFns } from "./SaledCouponList.vue?vue&type=template&id=05bf5911"
import script from "./SaledCouponList.vue?vue&type=script&lang=js"
export * from "./SaledCouponList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports